export const multiLingual = () => {
  let lang = localStorage.getItem("lang");
  return lang === "hindi"
    ? {
        "Enter your mobile number or email": "मोबाइल नंबर / ईमेल*",
        "Enter Mobile Number": "मोबाइल नंबर*",
        Password: "पासवर्ड*",
        "First Name": "पहला नाम*",
        "Last Name": "उपनाम*",
        Email: "ईमेल*",
        "Phone Number": "फ़ोन नंबर*",
        "Re-Enter Password": "पासवर्ड फिर से दर्ज करें*",
        "GST Number": "जीएसटी नंबर",
        "PAN Number": "पैन कार्ड",
        "Profile Image": "प्रोफ़ाइल छवि",
        "Select Type": "प्रकार चुनें*",
        "Enter a Location": "शहर दर्ज करें*",
        "Quantity(MT)": "कुल मात्रा",
        Availability: "उपलब्धता",
        Commodity: "कमोडिटी",
        "Landline Number": "लैंडलाइन नंबर",
        "E-mail Address": "ईमेल पता*",
        Location: "शहर*",
        "What is your Requirement ?": "आपकी आवश्यकता क्या है?*",
        Warehouse: "गोदाम",
        Variety: "वैराइटी",
        "Indicative Price Per MT": "प्रति मीट्रिक टन सूचक मूल्य (* परक्राम्य)",
        "Quantity To Be Traded": "ट्रेड होने की कुल मात्रा",
        REMARKS: "टिप्पणियों",
        "Email Address": "ईमेल पता*",
        "Warehouse Owner address": "गोदाम के मालिक का पता*",
        "Warehouse Name": "गोदाम का नाम*",
        Capacity: "क्षमता*",
        "Area in Sqft of Warehouse": "गोदाम का क्षेत्रफल*",
        "Pin Code": "पिन कोड*",
        "Warehouse Address Line 1": "गोदाम पता लाइन 1*",
        "Warehouse Address Line 2": "गोदाम पता लाइन 2",
        "Start Date": "आरंभ करने की तिथि*",
        District: "जिला*",
        "Sign In": "साइन-इन करें",
        "Create Account": "साइन-अप करें",
        "Request a Quote": "अनुरोध करे ",
        "enter your email id": "अपनी ईमेल आईडी दर्ज करें",
        "Sign up with your email ID": "अपनी ईमेल आईडी से साइन अप करें",
        "Not Registered yet? Create an account now!":
          "अभी तक साइन अप नहीं किया है? अभी अपना एक खाता बनाएँ!",
        "Search By Warehouse Name": "गोदाम के नाम से खोजें",
        "Search By Warehouse Code": "वेयरहाउस कोड द्वारा खोजें",
        "Funding Location": "फंडिंग स्थान",
        "Enter your name": "अपना नाम दर्ज करें",
        "Enter your phone number": "अपना फोन नंबर डालें",
        "Enter your email ID": "अपना ईमेल आईडी दर्ज करें",
        "Enter No. of Remit Bags": "प्रेषण बैगों की संख्या दर्ज करें",
        "Enter Remit Amount": "प्रेषण राशि दर्ज करें",
        "Remit Date": "प्रेषण तिथि",
        Pincode: "पिन कोड",
        Search: "खोज",
        "Search State": "राज्य द्वारा खोजें",
        "Search City": "शहर द्वारा खोजें",
        Minimum: "न्यूनतम",
        Maximum: "अधिकतम",
      }
    : {
        "Enter your mobile number or email":
          "Enter your mobile number or email*",
        "Enter Mobile Number": "Enter Mobile Number*",
        Password: "Password*",
        "First Name": "First Name*",
        "Last Name": "Last Name*",
        Email: "Email*",
        "Phone Number": "Phone Number*",
        "Re-Enter Password": "Re-Enter Password*",
        "GST Number": "GST Number",
        "PAN Number": "PAN Number",
        "Profile Image": "Profile Image",
        "Select Type": "Select Type*",
        "Enter a Location": "Enter a Location*",
        "Quantity(MT)": "Quantity(MT)",
        Availability: "Availability",
        Commodity: "Commodity",
        "Landline Number": "Landline Number",
        "E-mail Address": "E-mail Address*",
        Location: "Location*",
        "What is your Requirement ?": "What is your Requirement ?*",
        Warehouse: "Warehouse",
        Variety: "Variety",
        "Indicative Price Per MT": "Indicative Price Per MT",
        "Quantity To Be Traded": "Quantity To Be Traded",
        REMARKS: "REMARKS*",
        "Email Address": "Email Address*",
        "Warehouse Owner address": "Warehouse Owner address*",
        "Warehouse Name": "Warehouse Name*",
        Capacity: "Capacity*",
        "Area in Sqft of Warehouse": "Area in Sqft of Warehouse*",
        "Pin Code": "Pin Code*",
        "Warehouse Address Line 1": "Warehouse Address Line 1*",
        "Warehouse Address Line 2": "Warehouse Address Line 2",
        "Start Date": "Start Date*",
        District: "District*",
        "Sign In": "Sign In",
        "Create Account": "Create Account",
        "Not Registered yet? Create an account now!":
          "Not Registered yet? Create an account now!",
        "Request a Quote": "Request a Quote",
        "enter your email id": "enter your email id",
        "Sign up with your email ID": "Sign up with your email ID",
        "Search By Warehouse Name": "Search By Warehouse Name",
        "Search By Warehouse Code": "Search By Warehouse Code",
        "Funding Location": "Funding Location",
        "Enter your name": "Enter your name",
        "Enter your phone number": "Enter your phone number",
        "Enter your email ID": "Enter your email ID",
        "Enter No. of Remit Bags": "Enter No. of Remit Bags",
        "Enter Remit Amount": "Enter Remit Amount",
        "Remit Date": "Remit Date",
        Pincode: "Pincode",
        Search: "Search",
        "Search State": "Search State",
        "Search City": "Search City",
        Minimum: "Minimum",
        Maximum: "Maximum",
      };
};
